import React from "react";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { FORM_URL_JAPAN } from "../../data/courseDataJapan";

import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

const JapanCorporateForm = () => {
  const [company, setCompany] = React.useState("");
  const [contactName, setContactName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [headcount, setHeadcount] = React.useState("");
  const [language, setLanguage] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!company) return NotificationManager.error("会社名を入力してください");
    if (!contactName) return NotificationManager.error("ご担当者名を入力してください");
    if (!email) return NotificationManager.error("メールアドレスを入力してください");
    if (!phone || !isValidPhoneNumber(phone)) {
      return NotificationManager.error("有効な電話番号を入力してください");
    }
    if (!language) return NotificationManager.error("ご希望の言語を選択してください");

    setLoading(true);

    const interest = "Corporate Training (Japan Market)";
    const summary = [
      "Corporate Training Inquiry (Japan Market)",
      `Company: ${company}`,
      `Employees/Participants: ${headcount || "N/A"}`,
      `Language: ${language}`,
      `Message: ${message || "N/A"}`,
      "Source: Japan Corporate Page",
    ].join(" | ");

    try {
      const formData = new FormData();
      formData.append("entry.1102309209", `${contactName} (${company})`);
      formData.append("emailAddress", email);
      formData.append("entry.774180726", phone);
      formData.append("entry.1793295208", interest);
      formData.append("entry.371784238", summary);

      await fetch(FORM_URL_JAPAN, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      });

      NotificationManager.success("お問い合わせを受け付けました!");

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "lead_form_submit",
        course_interest: interest,
        page_path: window.location.pathname,
        form_type: "corporate_inquiry_japan",
      });

      setSubmitted(true);
    } catch (error) {
      NotificationManager.error("エラーが発生しました。もう一度お試しください。");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="contact__card jl-thank-you">
        <div className="jl-thank-you__icon">✓</div>
        <h5>お問い合わせありがとうございます!</h5>
        <p>
          担当者より2営業日以内にご連絡し、貴社に合った研修プランをご提案いたします。
        </p>
        <a href="mailto:admin@koderbox.com" className="btn btn-primary">
          admin@koderbox.com
        </a>
      </div>
    );
  }

  return (
    <div className="contact__card">
      <form onSubmit={handleSubmit} className="contact__card--form">
        <h5>法人研修についてのお問い合わせ</h5>
        <p className="jl-form-subtext">貴社の課題に合わせた研修プランをご提案します。</p>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="text"
            placeholder="会社名"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            required
          />
        </div>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="text"
            placeholder="ご担当者名"
            value={contactName}
            onChange={(e) => setContactName(e.target.value)}
            required
          />
        </div>

        <div className="contact__card--form-control">
          <PhoneInput
            className="form-control"
            international
            defaultCountry="JP"
            value={phone}
            onChange={(value) => {
              if (!value || value.length <= 15) {
                setPhone(value);
              }
            }}
            placeholder="電話番号を入力"
          />
        </div>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="email"
            placeholder="メールアドレス"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="contact__card--form-control">
          <input
            className="form-control"
            type="text"
            placeholder="受講予定人数(目安)"
            value={headcount}
            onChange={(e) => setHeadcount(e.target.value)}
          />
        </div>

        <div className="contact__card--form-control">
          <select
            className="form-control"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            required
          >
            <option value="">ご希望の言語</option>
            <option value="英語">英語(英会話研修)</option>
            <option value="日本語">日本語研修(外国籍社員向け)</option>
            <option value="ドイツ語">ドイツ語</option>
            <option value="フランス語">フランス語</option>
            <option value="スペイン語">スペイン語</option>
            <option value="韓国語">韓国語</option>
            <option value="中国語">中国語</option>
            <option value="複数言語">複数言語・その他</option>
          </select>
        </div>

        <div className="contact__card--form-control">
          <textarea
            className="form-control"
            placeholder="ご要望・メッセージ(任意)"
            rows={3}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? "送信中..." : "お問い合わせを送信する →"}
        </button>
      </form>

      <NotificationContainer />
    </div>
  );
};

export default JapanCorporateForm;
